<div class="wrapper-popover" [@fadeInOnEnter] [@fadeOutOnLeave]>
    <h2 class="box-title">
        About Multi-Vehicle Connect feature with your plan 
    </h2>
    <div class="main-text-box">
        <p>
            Multi-Vehicle connect enables you to access your data from qualified vehicles paired with your plan.
        </p>
        <ul class="text-list">
            <li>
                As part of the Multi-Vehicle Connect feature, this plan allows your data to be used in up to three vehicles. 
            </li>
            <li>
                In order to take advantage of this feature, you will need to pair the vehicle with this plan through the in-vehicle dashboard or your vehicle’s mobile app.
            </li>
            <li>
                Each vehicle that you pair with this plan will appear as a separate line item in your monthly bill.
            </li>
            <li>
                You may unpair a vehicle at any time using your in-vehicle dashboard or mobile app.
            </li>
        </ul>
        <p class="bold-text">
            Additional Taxes and Fees will apply when using Multi-Vehicle Connect feature
        </p>
    </div>
    <div class="button-box">
        <app-main-button
            (onClick)="onContinue()"
            [buttonWidth]="'92vw'"
            [border]="'1px solid #000000'"
            [textColor]="'#FFFFFF'"
            [backgroundColor]="'#000000'"
            [buttonText]="'Continue'">
        </app-main-button>
    </div>
  </div>